export default {
  default: () => import("/var/www/layouts/default.vue").then(m => m.default || m),
  manage: () => import("/var/www/layouts/manage.vue").then(m => m.default || m),
  ua: () => import("/var/www/layouts/ua.vue").then(m => m.default || m)
}